import { Pagination } from "@mui/material";
import { DownloadIcon } from "@radix-ui/react-icons";
import { BarCode01Icon } from "hugeicons-react";
import { MoreHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import model from "../../assets/model-fichier/model-numeroFtth.xlsx";
import { Loader } from "../../components/Widget/Loader";
import { UploadButton } from "../../components/Widget/UploadButton";
import clientAxios from "../../services/axios";
import { store } from "../../services/service";
import { useGlobalStore } from "../../store/store";
import {
  BASE_URL,
  ENREGISTRER_NUMERO_FFTH,
  EXPORTER_NUMERO_FTTH,
  IMPORTER_NUMERO_FTTH,
  LISTE_NUMERO_FTTH,
  MODIFICATION_NUMERO_FTTH,
  SUPPRIMER_NUMERO_FTTH,
} from "../../Utils/constant";
import { checkTagValidity, userToken } from "../../Utils/Utils";

export const NumeroFtth = () => {
  const numeroFtth = useGlobalStore();
  const [selectItem, setSelectItem] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectStatut, setSelectStatut] = useState("");
  const [statut, setStatut] = useState("LIBRE");
  const [plageDebut, setPlageDebut] = useState("");
  const [plageFin, setPlageFin] = useState("");
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [pid, setPid] = useState(null);

  const handleDownload = () => {
    setLoading(true);
    fetch(
      `${
        BASE_URL + EXPORTER_NUMERO_FTTH
      }?plageDebut=${plageDebut}&statut=${statut}&plageFin=${plageFin}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      },
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `LISTE_NUMERO_FTTH.xlsx`; // spécifiez le nom du fichier et son extension
        document.body.appendChild(a);
        a.click();
        setLoading(false);
        document.getElementById("export").close();
      })
      .catch((err) => console.error("Erreur de téléchargement:", err));
  };

  const handleEdit = () => {
    setIsSubmit(true);
    store(
      `${MODIFICATION_NUMERO_FTTH}/${selectItem?.id}?status=${statut}&pid=${pid}`,
    )
      .then(() => {
        setIsSubmit(false);
        numeroFtth.getData(
          `${LISTE_NUMERO_FTTH}?page=0&param=&status=&size=40`,
          "application/json",
          {},
        );
        toast.success("Modification avec succès");
        document.getElementById("update").close();
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
        document.getElementById("update").close();
      });
  };

  const submit = (data) => {
    setIsSubmit(true);
    store(
      `${ENREGISTRER_NUMERO_FFTH}?plageDebut=${Number(
        data.plageDebut,
      )}&plageFin=${Number(data.plageFin)}`,
      "application/json",
      {},
    )
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          document.getElementById("add").close();
          toast.success("Créer avec succès");
          numeroFtth.getData(
            `${LISTE_NUMERO_FTTH}?page=0&param=&status=&size=40`,
          );
        }
      })
      .catch((err) => {
        document.getElementById("fermer_create").click();
        setIsSubmit(false);
        setMsg(err.response.data.donnee);
      });
  };
  useEffect(() => {
    numeroFtth.getData(`${LISTE_NUMERO_FTTH}?page=0&param=&status=&size=40`);
  }, []);

  const more = (page) => {
    numeroFtth.getData(
      `${LISTE_NUMERO_FTTH}?page=${page - 1}&param=&status=&size=40`,
    );
  };

  return (
    <>
      {checkTagValidity("LISTE_NUMERO_FTTH") ? (
        <div>
          <div className="mb-6">
            <h3 class="font-mtn text-3xl font-bold">
              Gestion des numéros FTTH
            </h3>
            <p className="text-sm text-gray-500">
              Liste des numéros FTTH disponibles dans le système pour les
              abonnements clients.
            </p>
          </div>
          <div className="mt-4 lg:flex item-center gap-4">
            <input
              onChange={(e) => {
                numeroFtth.getData(
                  `${LISTE_NUMERO_FTTH}?page=0&param=${e.target.value}&status=&size=40`,
                );
              }}
              type="text"
              placeholder="Rechercher element..."
              className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
            />
            <select
              className="select select-bordered w-60 h-10"
              onChange={(e) => {
                setSelectStatut(e.target.value);
                numeroFtth.getData(
                  `${LISTE_NUMERO_FTTH}?page=0&param=&status=${e.target.value}&size=40`,
                );
              }}
            >
              <option value="">Filtrer par statut</option>
              <option value="LIBRE">LIBRE</option>
              <option value="RESERVER">RESERVER</option>
              <option value="EN_ATTENTE_LIBERATION">
                EN ATTENTE DE LIBERATION
              </option>
              <option value="EN_ATTENTE_ACTIVATION">
                EN ATTENTE D'ACTIVATION
              </option>
              <option value="ALLOUER">ALLOUER</option>
            </select>
            <div className="ml-auto flex items-center">
              <UploadButton
                uploadUrl={IMPORTER_NUMERO_FTTH}
                fetchData={() => {
                  numeroFtth.getData(
                    `${LISTE_NUMERO_FTTH}?page=0&param=&status=&size=40`,
                  );
                }}
                model={model}
              />
              {checkTagValidity("EXPORTER_NUMERO_FTTH") ? (
                <>
                  <button
                    onClick={() => {
                      document.getElementById("export").showModal();
                    }}
                    className="btn btn-sm ml-auto  bg-black text-white"
                  >
                    <DownloadIcon /> Exporter la liste
                  </button>

                  <dialog id="export" className="modal ">
                    <div className="modal-box lg:w-96 w-full">
                      <div className="modal-action">
                        <h1 className="mr-auto text-xl font-bold">
                          Exporter la liste des numéros FTTH
                        </h1>
                        <form method="dialog">
                          <button
                            id="fermer_create"
                            className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                          >
                            ✕
                          </button>
                        </form>
                      </div>
                      <p className="text-xs text-red-700">{error}</p>

                      <div className="my-4 space-y-4">
                        <div className="my-2">
                          <label htmlFor="" className="text-sm font-medium">
                            Plage debut
                          </label>
                          <input
                            type="text"
                            placeholder=""
                            className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                            onChange={(e) => {
                              setPlageDebut(e.target.value);
                            }}
                          />
                        </div>

                        <div className="my-2">
                          <label htmlFor="" className="text-sm font-medium">
                            Plage fin
                          </label>
                          <input
                            type="text"
                            placeholder=""
                            className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                            onChange={(e) => {
                              setPlageFin(e.target.value);
                            }}
                          />
                        </div>

                        <button
                          onClick={handleDownload}
                          disabled={loading}
                          className={`bg-main text-slate-800 bg-slate-200w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 flex items-center justify-center`}
                        >
                          {loading && (
                            <span className="loading loading-dots loading-xs mr-2"></span>
                          )}
                          {loading ? "Export en cours..." : "Exporter la liste"}
                        </button>
                      </div>
                    </div>
                  </dialog>
                </>
              ) : null}

              {checkTagValidity("ENREGISTRER_NUMERO_FTTH") ? (
                <button
                  onClick={() => document.getElementById("add").showModal()}
                  className="btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white"
                >
                  Générer un Numéro ftth
                </button>
              ) : null}

              <dialog id="add" className="modal ">
                <div className="modal-box ">
                  <div className="modal-action">
                    <h1 className="mr-auto text-2xl font-bold">
                      Générer un Numéro ftth
                    </h1>

                    <form method="dialog">
                      <button
                        id="fermer_create"
                        className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                      >
                        ✕
                      </button>
                    </form>
                  </div>
                  <form onSubmit={handleSubmit(submit)} className="px-2">
                    <p className="text-xs text-red-700">{msg}</p>
                    <div className="my-4 space-y-4">
                      <div className="my-2">
                        <label htmlFor="" className="text-sm font-medium">
                          Plage debut <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder=""
                          className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                          {...register("plageDebut", { required: true })}
                        />
                        {errors.plageDebut && (
                          <span className="text-sm text-rose-600">
                            Ce champs est obligatoire
                          </span>
                        )}
                      </div>

                      <div className="my-2">
                        <label htmlFor="" className="text-sm font-medium">
                          Plage fin <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder=""
                          className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                          {...register("plageFin", { required: true })}
                        />
                        {errors.plageFin && (
                          <span className="text-sm text-rose-600">
                            Ce champs est obligatoire
                          </span>
                        )}
                      </div>

                      <button
                        type="submit"
                        disabled={isSubmit}
                        className={`${
                          !isSubmit
                            ? "text-black bg-main"
                            : "text-slate-800 bg-slate-200 "
                        } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                      >
                        {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                        {isSubmit ? (
                          <span className="loading loading-dots loading-xs"></span>
                        ) : null}
                      </button>
                    </div>
                  </form>
                </div>
              </dialog>
            </div>
          </div>
          <dialog id="update" className="modal ">
            <div className="modal-box ">
              <div className="modal-action">
                <h1 className="mr-auto text-2xl font-bold">Modification</h1>
                <form method="dialog">
                  <button
                    id="fermer"
                    className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                  >
                    ✕
                  </button>
                </form>
              </div>
              <div className="my-2">
                <label htmlFor="" className="text-sm font-medium">
                  PID <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder=""
                  value={pid}
                  onChange={(e) => {
                    setPid(e.target.value);
                  }}
                  className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                />
                {errors.pid && (
                  <span className="text-sm text-rose-600">
                    Ce champs est obligatoire
                  </span>
                )}
              </div>
              <select
                className="select select-bordered w-full h-10 my-2"
                onChange={(e) => setStatut(e.target.value)}
              >
                <option value="LIBRE">Libre</option>
                <option value="RESERVER">Reservé</option>
              </select>
              <button
                onClick={handleEdit}
                disabled={isSubmit}
                className={`${
                  !isSubmit
                    ? "text-black bg-main"
                    : "text-slate-800 bg-slate-200 "
                } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
              >
                Modifier
              </button>
            </div>
          </dialog>
          <div className="grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-2 my-8">
            {numeroFtth?.data?.donnee?.data?.length === 0 ? (
              "Aucune donnée"
            ) : numeroFtth?.data?.donnee?.data?.length !== 0 &&
              !numeroFtth?.loading ? (
              numeroFtth?.data?.donnee?.data?.map((item) => (
                <div className="py-1 relative flex gap-1 items-center cursor-pointer text-black shadow-sm border bg-white  rounded text-xs">
                  <div className="dropdown dropdown-end absolute right-2 top-2">
                    <div
                      tabIndex={0}
                      role="button"
                      className="w-4 h-4 rounded-full flex items-center justify-center bg-gray-50"
                    >
                      <MoreHorizontal size={20} />
                    </div>
                    <ul
                      tabIndex={0}
                      className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                    >
                      <button
                        className="bg-white hover:bg-gray-100 text-gray-600 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                        onClick={() => {
                          setSelectItem(item);
                          setPid(item?.pid);
                          document.getElementById("update").showModal();
                        }}
                      >
                        Modifier
                      </button>
                      <button
                        onClick={() => {
                          setSelectItem(item);
                          document.getElementById("delete").showModal();
                        }}
                        className="bg-white hover:bg-red-600 text-black hover:text-white font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                      >
                        Supprimer
                      </button>
                    </ul>
                  </div>
                  <div className="bg-gray-100 w-10 h-10 rounded m-1 flex items-center justify-center">
                    <BarCode01Icon />
                  </div>
                  <div>
                    <p className="truncate w-36">{item?.numero}</p>
                    {item?.pid ? (
                      <p className="truncate w-36">PID: PI{item?.pid}</p>
                    ) : null}
                    <p className="rounded-full px-2 bg-slate-100 truncate w-fit">
                      {item?.status.replace(/_/g, " ").toLowerCase()}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <Loader />
            )}
          </div>
          <div className="my-3 flex justify-end">
            <Pagination
              onChange={(event, newValue) => more(newValue)}
              onSelect={(selectedPage) => more(selectedPage)}
              count={numeroFtth.data?.donnee?.totalPages}
              variant="outlined"
              color="primary"
              shape="rounded"
            />
          </div>
          <dialog id="delete" className="modal">
            <div className="modal-box max-w-md rounded-lg">
              <h3 className="font-extrabold text-xl text-red-600 ">
                Attention
              </h3>
              <p className="pt-2 text-black font-medium">
                Voulez vous vraiment effectuer cette action ?
              </p>
              <div className="modal-action">
                <form
                  method="dialog"
                  className="w-full flex items-center justify-end gap-x-4"
                >
                  <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                    Annuler
                  </button>
                  <button
                    onClick={() => {
                      setIsDeleting(true);
                      clientAxios
                        .delete(`${SUPPRIMER_NUMERO_FTTH}/${selectItem.id}`)
                        .then(() => {
                          numeroFtth.getData(
                            `${LISTE_NUMERO_FTTH}?page=0&param=&size=10`,
                          );
                          toast.success("Numéro supprimé avec succès");
                        })
                        .catch((err) => {
                          toast.error(
                            err?.response?.data?.donnee ||
                              "Erreur lors de la suppression",
                          );
                        })
                        .finally(() => {
                          setIsDeleting(false);
                          const dlg = document.getElementById("delete");
                          if (dlg) dlg.close();
                        });
                    }}
                    disabled={isDeleting}
                    className={`w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold ${
                      isDeleting
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-red-600 text-white"
                    }`}
                  >
                    {isDeleting ? (
                      <div className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    ) : null}
                    <span className="ml-2">
                      {isDeleting ? "Suppression..." : "Supprimer"}
                    </span>
                  </button>
                </form>
              </div>
            </div>
          </dialog>
        </div>
      ) : null}
    </>
  );
};
